export const modalTitle = 'Deactivate Customers.ai Referral Partner membership';
export const modalDescription =
  'If you deactivate your membership in the Customers.ai Referral Partner Program,' +
  ' you will no longer receive commissions for your referrals,' +
  ' and your affiliate link will no longer attribute new customers to your account';
